<div class="container mt-4">
  <div class="row mb-5">
    <div *ngIf="activationEmailState == ActivateEmailStates.OngoingActivation">Activating your account...</div>
    <div *ngIf="activationEmailState == ActivateEmailStates.Activated">Your account has been activated, you're getting redirected!</div>
    <div *ngIf="activationEmailState == ActivateEmailStates.FailedActivation">{{errorMessage}}</div>
  </div>
</div>
